/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersQuestEventDto interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersQuestEventDto(value) {
    if (!('Code' in value) || value['Code'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON(json) {
    return FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Code': json['Code'],
    };
}
export function FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON(json) {
    return FxIdApplicationCrossPlayHandlersQuestEventDtoToJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersQuestEventDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Code': value['Code'],
    };
}
//# sourceMappingURL=FxIdApplicationCrossPlayHandlersQuestEventDto.js.map